import React, { useRef, useState } from 'react';
import './Footer.css';
import footerlogo from '../../images/footerlogo.png';
import emailjs from 'emailjs-com';
import Modal from '../Contact/Modal';

const Footer = () => {
    const form = useRef();
    const [modalOpen, setModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState("");

    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
            .sendForm(
                "service_a401exi",       // EmailJS service ID
                "template_l3t3ct7",      // EmailJS template ID
                form.current,
                "GdcFGQyr90SeuvJsr"      // EmailJS user/public key
            )
            .then(
                () => {
                    setModalMessage("Message sent successfully!");
                    setModalOpen(true);
                    form.current.reset();
                },
                () => {
                    setModalMessage("Failed to send the message, please try again.");
                    setModalOpen(true);
                }
            );
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    return (
        <>
            <footer className="footer-content">
                <div className="footer container">
                    <div className="footer-cols-wrapper">
                        <FooterColumns />
                        <FooterCorporate />
                    </div>
                    <FooterContact form={form} sendEmail={sendEmail} />
                </div>
                <FooterBottom />
            </footer>

            <Modal isOpen={modalOpen} onClose={closeModal} message={modalMessage} />
        </>
    );
};

const FooterColumns = () => (
    <div className="footer-columns">
        <FooterLogo />
        <FooterMenu />
        <FooterCategories />
    </div>
);

const FooterLogo = () => (
    <div className="footer-col">
        <div className="footer-logo">
            <a href="/" title="Go to homepage">
                <img src={footerlogo} alt="Footer Logo" />
            </a>
        </div>
        <ul className='adress-box'>
            <li>Factory Addresses</li>
            <li className='noida'>Noida: <strong>H-212, First Floor, Sec-63, NOIDA-201301</strong></li>
            <li>Morena: <strong>coming soon</strong></li>
        </ul>
    </div>
);

const FooterMenu = () => (
    <div className="footer-col">
        <h4 className="title">Menu</h4>
        <ul className="menu">
            <li className="menu-item"><a href="/">Home</a></li>
            <li className="menu-item"><a href="/products">Products</a></li>
            <li className="menu-item"><a href="/investor">Investor</a></li>
            <li className="menu-item"><a href="/about">About</a></li>
            <li className="menu-item"><a href="/contact">Contact</a></li>
        </ul>
    </div>
);

const FooterCategories = () => (
    <div className="footer-col">
        <h4 className="title">Categories</h4>
        <ul className="menu">
            <li className="menu-item"><a href="/products/disposable-medical-wear-collection">Medical Wear</a></li>
            <li className="menu-item"><a href="/products/orthopedic-implants">Orthopedic Implants & Instruments</a></li>
            <li className="menu-item"><a href="/products/surgical-consumables">Surgical Consumables</a></li>
            <li className="menu-item"><a href="/products/orthopedic-consumables">Orthopedic Consumables</a></li>
        </ul>
    </div>
);

const FooterCorporate = () => (
    <div className="footer-corporate">
        <p>Corporate Office: B-23, First Floor, DDA SHED, Okhla Industrial Area, Phase 2. New Delhi-110020</p>
    </div>
);

const FooterContact = ({ form, sendEmail }) => (
    <div className="footer-col-wrapper">
        <div className="footer-col">
            <h4 className="title">Contact Me</h4>
            <form ref={form} className="contact-form" onSubmit={sendEmail}>
                <ContactField label="Name" type="text" name="from_name" />
                <ContactField label="Email" type="email" name="from_email" />
                <ContactField label="Message" type="textarea" name="message" />
                <div className="submit">
                    <input
                        id="submit-btn"
                        className="ninja-submit-btn"
                        type="submit"
                        value="Submit"
                        style={{ cursor: "pointer" }}
                    />
                </div>
            </form>
        </div>
    </div>
);

const ContactField = ({ label, type, name }) => (
    <div className="field-name required menu-item">
        <label className="label" htmlFor={name}>
            <span>{label}</span>
            <span className="ninja-forms-req-symbol">*</span>
        </label>
        <div className="control">
            {type === "textarea" ? (
                <textarea id={name} name={name} required></textarea>
            ) : (
                <input
                    type={type}
                    id={name}
                    name={name}
                    className="input-text required-entry"
                    required
                />
            )}
        </div>
    </div>
);

const FooterBottom = () => (
    <div id="footer-bottom">
        <div className="container clearfix">
            <div id="footer-info">Developed by UdeyTech</div>
        </div>
    </div>
);

export default Footer;
